"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _styles = require("@material-ui/core/styles");

var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var theme = (0, _styles.createMuiTheme)({
  // For Underline Color After Click
  palette: {
    primary: {
      main: "rgba(255, 255, 255, 1)"
    }
  },
  // For Underline Hover Color
  overrides: {
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: '1px solid #ffffff !important'
        },
        '&:after': {
          borderBottom: '2px solid #ffffff !important'
        }
      },
      root: {
        // Name of the rule
        color: 'white' // Some CSS

      }
    }
  }
});

var AppNumberField = /*#__PURE__*/function (_React$Component) {
  _inherits(AppNumberField, _React$Component);

  function AppNumberField() {
    _classCallCheck(this, AppNumberField);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppNumberField).apply(this, arguments));
  }

  _createClass(AppNumberField, [{
    key: "getClassName",

    /**
     * Get class name
     *
     * @returns {string}
     */
    value: function getClassName() {
      var classNames = ['input-group'];

      if (this.props.fullWidth) {
        classNames.push('fulled');
      }

      return classNames.join(' ');
    }
    /**
     * Handle input change
     *
     * @param e
     */

  }, {
    key: "handleInputChange",
    value: function handleInputChange(e) {
      this.props.handler.handleInputChange(this.props.name, e.formattedValue);
    }
  }, {
    key: "getValidationError",
    value: function getValidationError() {
      var _this = this;

      var messages = [];
      this.props.handler.getErrors().filter(function (x) {
        return x.field == _this.props.name;
      }).forEach(function (error) {
        return messages.push(error.message);
      });

      if (messages.length == 0) {
        return null;
      } // if (this.props.value.length != 0 ) {
      //   return null;
      // }


      return _react["default"].createElement("div", {
        className: "validation-message",
        key: this.props.name + '-error'
      }, messages.join("<br/>"));
    }
    /**
     * Render input
     *
     * @returns {XML}
     */

  }, {
    key: "render",
    value: function render() {
      var className = this.getClassName();
      var validationError = this.getValidationError();
      return _react["default"].createElement("div", {
        className: className,
        id: validationError ? "standard-error" : ''
      }, _react["default"].createElement(_styles.MuiThemeProvider, {
        theme: theme
      }, _react["default"].createElement(_reactNumberFormat["default"], {
        margin: "normal",
        error: validationError ? true : false,
        label: this.props.label,
        placeholder: this.props.placeholder,
        type: this.props.type,
        name: this.props.name,
        format: this.props.format,
        mask: this.props.mask,
        style: {
          width: '100%'
        },
        customInput: _TextField["default"],
        value: this.props.value,
        onValueChange: this.handleInputChange.bind(this)
      })), validationError);
    }
  }]);

  return AppNumberField;
}(_react["default"].Component);

exports["default"] = AppNumberField;